module.exports = __webpack_public_path__ + "img/notice-back.270ebe1c.jpg";